import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import CombinedProgress from 'legacy/src/components/assignment/components/CombinedProgress';

const LockedProgressBar = ({
  assignmentProgress,
  isScheduled,
  startsAt,
  dueAt,
  hasStudents,
}) => {
  let message;
  let isLocked;

  if (!hasStudents) {
    message = '0';
  } else if (!isScheduled) {
    isLocked = true;
    if (startsAt) {
      const startsAtDate = dayjs(startsAt);
      const dueAtDate = dayjs(dueAt);
      const dueDateString = dueAt
        ? ` - ${dueAtDate.format('MM')}/${dueAtDate.format('DD')}`
        : '';
      message = ` Scheduled: ${startsAtDate.format('MM')}/${startsAtDate
        .add()
        .format('DD')}${dueDateString}`;
    } else {
      message = 'no results';
    }
  } else {
    isLocked = false;
  }

  return (
    <CombinedProgress
      data-test-locked-bar
      isSmall
      isLocked={isLocked}
      progress={assignmentProgress}
      showLabels={false}
      message={<span>{message}</span>}
      className="progress-bar"
      showMessageOnBar
      alwaysSmall
    />
  );
};

LockedProgressBar.propTypes = {
  assignmentProgress: PropTypes.object.isRequired,
  isScheduled: PropTypes.bool.isRequired,
  startsAt: PropTypes.string.isRequired,
  dueAt: PropTypes.string.isRequired,
};

export default LockedProgressBar;
